import { Component, OnInit } from "@angular/core";
import { BaseControlComponent } from "../../../../../../../form-controls/components/base-control/base-control.component";
import { ContextInteractionService } from "../../../../../../../form-controls/services/context-interaction.service";

@Component({
    selector: "app-map-control-data-config",
    templateUrl: "./map-control-data-config.component.html",
    styleUrls: ["./map-control-data-config.component.scss"],
    standalone: false
})
export class MapControlDataConfigComponent extends BaseControlComponent implements OnInit {
    static componentName = "MapControlDataConfigComponent";
    rendererTypes = Object.values(RendererTypes);

    constructor(public readonly contextService: ContextInteractionService) { super(contextService); }

    ngOnInit() {
        super.ngOnInit(); 
        this.initializeConfig();
        
    }

    initializeConfig(): void {
        if (!this.componentData.config.rendererType)
            this.componentData.config.rendererType = RendererTypes.View;

        if (!this.componentData.config.properties)
            this.componentData.config.properties = {
                zoom: 18
            }

        if (!this.componentData.config.contextLocations)
            this.componentData.config.contextLocations = {};
    }
}

export enum RendererTypes {
    View = "View",
    Scene = "Scene",
    CasingPlan = "Casing Plan 3D",
    AreaOfReview = "Area of Review",
    Route = "Route"
}
